import React from 'react'

const VIEWBOX_WIDTH = 176
const VIEWBOX_HEIGHT = 112

export interface FreezerBoxIconProps {
  className?: string
  size?: number
}

export const FreezerBoxIcon: React.FC<FreezerBoxIconProps> = ({
  className,
  size = VIEWBOX_WIDTH,
}) => (
  <svg
    className={className}
    width={size}
    height={Math.round((size * VIEWBOX_HEIGHT) / VIEWBOX_WIDTH)}
    viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M175.188 21.6114L105.552 90.8297C103.517 92.8568 100.748 93.9952 97.868 94H5.42208C2.44042 93.9808 0 91.5358 0 88.572C0 87.155 0.560571 85.7908 1.55607 84.7773L66.5533 20.3624C68.583 18.2729 71.3617 17.0624 74.2853 17H173.303C174.782 17.0048 176 18.2201 176 19.69C176 20.4105 175.705 21.107 175.188 21.6114Z"
      fill="#E8EFF8"
    />
    <rect
      x="49"
      y="18"
      width="78"
      height="56"
      rx="3"
      fill="white"
      stroke="#220C4A"
      strokeWidth="2"
    />
    <rect
      x="108"
      y="59"
      width="46"
      height="31"
      fill="white"
      stroke="#220C4A"
      strokeWidth="2"
    />
    <rect x="112" y="63" width="38" height="26" fill="#F5F5F5" />
    <rect x="135" y="79" width="12" height="7" fill="#E0E0E0" />
    <rect
      x="126"
      y="59"
      width="10"
      height="10"
      fill="#2CE27E"
      stroke="#220C4A"
      strokeWidth="2"
    />
    <line x1="48" y1="28" x2="77" y2="28" stroke="#220C4A" strokeWidth="2" />
    <line x1="53" y1="69" x2="64" y2="69" stroke="#220C4A" strokeWidth="2" />
    <line x1="53" y1="65" x2="64" y2="65" stroke="#220C4A" strokeWidth="2" />
    <line x1="85" y1="28" x2="128" y2="28" stroke="#220C4A" strokeWidth="2" />
    <line x1="79" y1="28" x2="83" y2="28" stroke="#220C4A" strokeWidth="2" />
    <rect
      x="63"
      y="23"
      width="8"
      height="10"
      rx="1"
      fill="white"
      stroke="#220C4A"
      strokeWidth="2"
    />
    <rect
      x="105"
      y="23"
      width="8"
      height="10"
      rx="1"
      fill="white"
      stroke="#220C4A"
      strokeWidth="2"
    />
    <circle cx="88" cy="51" r="16" fill="#13D2FC" />
    <path
      d="M88 39V44.4545M88 63V57.5455M88 44.4545L84 41.1818M88 44.4545L92 41.1818M88 44.4545V57.5455M88 57.5455L84 60.8182M88 57.5455L92 60.8182"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M77.6361 44.9949L82.3599 47.7222M98.4207 56.9949L93.6969 54.2676M82.3599 47.7222L77.8892 48.9201M82.3599 47.7222L81.162 43.2516M82.3599 47.7222L93.6969 54.2676M93.6969 54.2676L94.8948 58.7383M93.6969 54.2676L98.1676 53.0697"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M77.6412 56.9764L82.365 54.2491M98.4259 44.9764L93.7021 47.7036M82.365 54.2491L81.1671 58.7197M82.365 54.2491L77.8944 53.0512M82.365 54.2491L93.7021 47.7036M93.7021 47.7036L98.1727 48.9015M93.7021 47.7036L94.9 43.233"
      stroke="white"
      strokeWidth="2"
    />
    <rect x="69" y="24" width="1" height="8" fill="#E0E0E0" />
    <rect x="111" y="24" width="1" height="8" fill="#E0E0E0" />
    <rect x="118" y="21" width="6" height="4" fill="#F5F5F5" />
    <rect x="118" y="31" width="6" height="27" fill="#F5F5F5" />
    <path
      d="M141 34C143.209 34 145 32.2091 145 30C145 27.7909 143.209 26 141 26C138.791 26 137 27.7909 137 30C137 32.2091 138.791 34 141 34Z"
      stroke="#13D2FC"
      strokeWidth="2"
      strokeMiterlimit="1.5"
      strokeDasharray="2 2"
    />
    <path
      d="M34 67C35.1046 67 36 66.1046 36 65C36 63.8954 35.1046 63 34 63C32.8954 63 32 63.8954 32 65C32 66.1046 32.8954 67 34 67Z"
      stroke="#13D2FC"
      strokeWidth="2"
      strokeMiterlimit="1.5"
      strokeDasharray="2 2"
    />
    <path
      d="M162 50C163.105 50 164 49.1046 164 48C164 46.8954 163.105 46 162 46C160.895 46 160 46.8954 160 48C160 49.1046 160.895 50 162 50Z"
      stroke="#8664FF"
      strokeWidth="2"
      strokeMiterlimit="1.5"
      strokeDasharray="2 2"
    />
    <path
      d="M38 17C40.2091 17 42 15.2091 42 13C42 10.7909 40.2091 9 38 9C35.7909 9 34 10.7909 34 13C34 15.2091 35.7909 17 38 17Z"
      stroke="#2CE27E"
      strokeWidth="2"
      strokeMiterlimit="1.5"
      strokeDasharray="2 2"
    />
  </svg>
)

export default FreezerBoxIcon
